import ReportController from './report.controller';

export default class CountryReportController extends ReportController
{
	get endpoint() {
		return 'country';
	}

	get title() {
		return 'Country Report';
	}
}



/** WEBPACK FOOTER **
 ** ./resources/assets/js/controllers/country.report.controller.js
 **/